export default __webpack_public_path__ + "static/media/cross_off.6cdd82f0.svg";